import React from "react";
import { Grid, Typography } from "@mui/material";
import Loader from "components/loader/Loader";
import CommonNoDataFound from "components/CommonNoDataFound/CommonNoDataFound";

function FaqQuestion(props) {
  return (
    <Grid container>
      <Grid
        item
        alignItems="center"
        justifyContent="center"
        className={" font18 width100"}
      >
        {(props?.faqSectionLoader ||  props?.faqLoader)
        ? <Loader /> 
        : props?.faqData?.length > 0 ? (
          props?.faqData?.map((ele, idx) => (
            <Grid container key={idx} className="bgFaq">
              <Grid item md={11}>
                <Typography className="question">
                  <span>{idx + 1}.</span>
                  {ele.question}
                </Typography>
                <Typography className="answer mt3">{ele.answer}</Typography>
              </Grid>
            </Grid>
          ))
        ):  (<CommonNoDataFound />) }
      </Grid>
    </Grid>
  );
}

export default FaqQuestion;